(function () {
    'use strict';

    angular.module("imApp").factory("paperLessProductionService", ['$ihttp', function ($ihttp) {
        let service = {
            getPaperLessProduction: function () {
                return $ihttp.post({
                    method: 2054,
                    parameters: {}
                });
            }
        };

        return service;
    }]);
})();
